import presetTrendVideo from '@media-ui/pypo-article/src/containers/Article/presets/articlePresetTrendVideo';
export const presetMediaTrend = (isAsyncArticle?: boolean) => presetTrendVideo(({ Component: MediaTrend, props }) => (<MediaTrend {...props} needUpdate={isAsyncArticle}/>));
